import { useMemo } from "react";
import { MultiSelect } from "react-multi-select-component"

import createSelectModelOptions from "../../utils/createSelectModelOptions"
import { useStore } from "../../utils/ctx/SellingPageContext"

const ModelsFilter = () => {
  const [store, setStore] = useStore((store) => store);
  const { models, preFilteredModel: filteredModel, selectedModels, selectedBrands } = useMemo(() => store, [store]);

  if (filteredModel) {
    return null;
  }

  const selectOptions =
    !filteredModel && models ? createSelectModelOptions(models, selectedBrands) : null

  const handleModelsFiltersChange = (values: MultiSelectOnChangeParams[]) => {
    setStore({ selectedModels: values.map(model => model.value), page: 1, searchQuery: '' });
  }

  return (
    <>
      <b>Por Modelo</b>
      <MultiSelect
        options={selectOptions}
        value={selectedModels.map(model => ({
          label: model,
          value: model,
        }))}
        onChange={handleModelsFiltersChange}
        labelledBy="Select"
      />
    </>
  );
}

type MultiSelectOnChangeParams = {
  label: string;
  value: string;
}

export default ModelsFilter;
